import { useState, useEffect } from "react";
import { useTextPersistence } from "qwanyx";

export const useSelectLogic = ({ value, qwantumId, onSave, setProp, enabled }) => {
  const { text, handleBlur: persistenceBlur } = useTextPersistence(qwantumId, onSave);
  
  // Always use local state for the current value
  const [currentValue, setCurrentValue] = useState(() => {
    return value || text || "";
  });

  // Sync with props/persistence when they change
  useEffect(() => {
    const externalValue = value || text || "";
    setCurrentValue(externalValue);
  }, [value, text]);

  const handleChange = (e) => {
    let newValue;
    
    if (e.target.multiple) {
      // Handle multiple selection
      const selectedOptions = Array.from(e.target.selectedOptions);
      newValue = selectedOptions.map(option => option.value);
    } else {
      // Handle single selection
      newValue = e.target.value;
    }
    
    // Always update local state first for immediate UI response
    setCurrentValue(newValue);
    
    // Update CraftJS props when in editor mode
    if (enabled && setProp) {
      setProp(props => props.value = newValue);
    }
    
    // Handle persistence and callbacks
    if (onSave) {
      onSave(newValue);
    }
  };

  const handleBlur = (e) => {
    // Update the target value to current state before persistence
    if (e.target) {
      e.target.value = currentValue;
    }
    
    if (qwantumId && persistenceBlur) {
      persistenceBlur(e);
    }
  };

  return {
    currentValue,
    handleChange,
    handleBlur
  };
};